import PublicLayout from '@/app/layouts/PublicLayout';

import { homeRoutes } from '@/features/public/home/home.routes';
import { aboutRoutes } from '@/features/public/about-us/about.routes';
import { blogsRoutes } from '@/features/public/blogs/blogs.routes';
import { careersRoutes } from '@/features/public/careers/careers.routes';
import NotFound from '@/components/ui/templates/NotFound';

const featureRoutes = [
  ...homeRoutes,
  ...aboutRoutes,
  ...blogsRoutes,
  ...careersRoutes,
  {
    path: '*',
    element: <NotFound />,
  }
];

export const publicRoutes = [
  {
    path: '/',
    element: <PublicLayout />,
    children: featureRoutes,
    
  },
];